export const Footer = () => (
    <footer data-testid="site-footer" className="bg-ink text-bone">
        <div className="mx-auto max-w-7xl px-5 pb-24 pt-20 sm:px-8">
            <div className="grid grid-cols-1 gap-12 border-b border-bone/15 pb-16 sm:grid-cols-3">
                <div data-testid="footer-address">
                    <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-bone/50">Visit</p>
                    <p className="mt-4 text-sm leading-relaxed text-bone/80">
                        412 Elm Street, next to King
                        <br />
                        Free parking on-site
                    </p>
                </div>
                <div data-testid="footer-hours">
                    <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-bone/50">Hours</p>
                    <p className="mt-4 text-sm leading-relaxed text-bone/80">
                        Mon–Thu · 8:00 – 6:30
                        <br />
                        Fri · 8:00 – 4:00
                        <br />
                        Sat · 9:00 – 1:00 · Sun closed
                    </p>
                </div>
                <div data-testid="footer-note">
                    <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-bone/50">Good to know</p>
                    <p className="mt-4 text-sm leading-relaxed text-bone/80">
                        No referral required
                        <br />
                        Direct-billing most extended-health plans
                        <br />
                        New patients usually seen within 7 days
                    </p>
                </div>
            </div>
            <h2
                data-testid="footer-massive-logo"
                className="select-none whitespace-nowrap pt-14 text-center font-syne text-[9vw] font-extrabold leading-[0.85] tracking-tighter text-bone lg:text-[7.8vw]"
                aria-hidden="true"
            >
                PHYSIO<span className="text-ochre">/</span>ELM
            </h2>
            <div className="mt-12 flex flex-wrap items-center justify-between gap-4 border-t border-bone/15 pt-6">
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-bone/40" data-testid="footer-copyright">
                    © 2026 Physio on Elm — fictional demo clinic
                </p>
                <a
                    href="#top"
                    data-testid="footer-back-to-top"
                    className="font-mono text-[10px] uppercase tracking-[0.2em] text-bone/60 transition-colors duration-300 hover:text-ochre"
                >
                    Back to top ↑
                </a>
            </div>
        </div>
    </footer>
);
